import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';
// eslint-disable-next-line
import { default as Loader } from 'react-redux-loading-bar';
import styles from './styles';
var useStyles = createUseStyles(styles);
function LoadingBar(props) {
  var classes = useStyles(props);
  var classNames = props.classNames;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.loaderContainer
  }, /*#__PURE__*/React.createElement(Loader, {
    updateTime: 100,
    progressIncrease: 8,
    maxProgress: 100,
    className: cx(classes.loader, classNames.loader)
  }));
}
LoadingBar.styles = styles;
LoadingBar.propTypes = {
  classNames: PropTypes.objectOf(PropTypes.string)
};
LoadingBar.defaultProps = {
  classNames: {}
};
export default LoadingBar;